import { Div, Flex, Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import { Icon } from 'src/design_system/atoms/icons/components/Icon'
import { GreetingCardImage } from '../../CallToActionCards/components/GreetingCardImage'
import { useContainerWidth } from 'src/hooks'

type GiftCardsLineItemProps = {
  from: string
  brand: string
  thumbnail: string
  currency: string
  amount: string
}

export const GiftCardsLineItem: React.FC<GiftCardsLineItemProps> = ({
  brand,
  from,
  thumbnail,
  currency,
  amount,
}) => {
  const [containerRef, containerWidth] = useContainerWidth()
  const shouldStack = containerWidth <= 450

  return (
    <Div
      ref={containerRef}
      display="grid"
      justifyContent="center"
      alignItems="center"
      columnGap="x1"
      width="100%"
      outset={{ bottom: 'x2_5' }}
      style={{ gridTemplateColumns: '75px 1fr', gridTemplateRows: '1fr' }}
    >
      <Flex width="75px" justifyContent="center">
        <GreetingCardImage
          previewUrl={thumbnail}
          cardId={'1'}
          width={'75px'}
          height={'50px'}
        />
      </Flex>
      <Div
        width="100%"
        alignItems="center"
        inset={{ horizontal: 'x2', vertical: 'x1_5' }}
        style={{
          backgroundColor: '#eef0f2',
          borderRadius: 16,
          display: 'flex',
        }}
      >
        <Div
          display="grid"
          width="100%"
          justifyItems="start"
          columnGap={shouldStack ? 'x1' : 'x2'}
          style={{
            gridTemplateColumns: '10px 1fr',
            gridTemplateRows: '1fr 1fr',
          }}
        >
          <Flex
            backgroundColor="#0395BD"
            width="3px"
            height="35px"
            outset={{ right: 'x2' }}
            borderRadius="default"
            style={{
              gridColumnStart: 1,
              gridRowStart: 1,
              gridColumnEnd: 1,
              gridRowEnd: 3,
              alignSelf: 'center',
            }}
          />
          <Div
            style={{
              gridColumnStart: 2,
              gridRowStart: 1,
              gridColumnEnd: shouldStack ? 4 : 2,
              gridRowEnd: 1,
              alignSelf: 'center',
            }}
          >
            <Text
              type="caption"
              content={brand}
              lineHeight={1.8}
              weight="bold"
              color="primaryHeading"
            />
          </Div>
          <Div
            style={{
              gridColumnStart: 2,
              gridRowStart: 2,
              gridColumnEnd: 2,
              gridRowEnd: 2,
              alignSelf: 'center',
            }}
          >
            <Flex alignItems="center">
              <Icon name="user" size={12} color="#0395BD" />
              <Text
                outset={{ left: 'x_5' }}
                type="footnote"
                weight="bold"
                content={from}
                lineHeight={1.2}
                style={{ color: '#0395BD' }}
              />
            </Flex>
          </Div>
        </Div>
        <Div>
          <Text type="caption" content="Amount" />
          <div
            style={{ display: 'flex', height: '100%', alignItems: 'center' }}
          >
            <div
              style={{
                display: 'flex',
                height: '100%',
                justifyContent: 'start',
              }}
            >
              <Text
                type="footnote"
                content={currency}
                style={{
                  fontWeight: 400,
                  paddingLeft: '0.5rem',
                  paddingRight: '0.25rem',
                  fontSize: '10px',
                }}
                inset={{ top: 'x_25' }}
              />
            </div>
            <Text
              type="body"
              weight="bold"
              content={amount}
              style={{ padding: 0 }}
            />
          </div>
        </Div>
      </Div>
    </Div>
  )
}
